import { validatenull } from '@/utils/validate'
import website from '@/config/website'

const keyName = website.key + '-'

// 存储localStorage
export const setStore = (params: any = {}) => {
	let { name, content, type } = params
	name = keyName + name
	const obj = {
		dataType: typeof content,
		content: content,
		type: type,
		datetime: new Date().getTime()
	}
	if (type) {
		window.sessionStorage.setItem(name, JSON.stringify(obj))
	} else {
		window.localStorage.setItem(name, JSON.stringify(obj))
	}
}

//获取localStorage
export const getStore = (params: any) => {
	let { name, debug } = params
	name = keyName + name
	let obj: any = {},
		content
	obj = window.sessionStorage.getItem(name)
	if (validatenull(obj)) obj = window.localStorage.getItem(name)
	if (validatenull(obj)) return
	try {
		obj = JSON.parse(obj)
	} catch {
		return obj
	}
	if (debug) {
		return obj
	}
	if (obj.dataType == 'string') {
		content = obj.content
	} else if (obj.dataType == 'number') {
		content = Number(obj.content)
	} else if (obj.dataType == 'boolean') {
		content = Boolean(obj.content)
	} else if (obj.dataType == 'object') {
		content = obj.content
	}
	return content
}

//删除localStorage
export const removeStore = (params: any = {}) => {
	let { name, type } = params
	name = keyName + name
	if (type) {
		window.sessionStorage.removeItem(name)
	} else {
		window.localStorage.removeItem(name)
	}
}

//获取全部localStorage
export const getAllStore = (params: any = {}) => {
	const list = []
	const { type } = params
	if (type) {
		for (let i = 0; i < window.sessionStorage.length; i++) {
			const rawKey = window.sessionStorage.key(i)
			if (!rawKey || !rawKey.startsWith(keyName)) continue
			list.push({
				name: rawKey,
				content: getStore({
					name: rawKey.replace(keyName, ''),
					type: 'session'
				})
			})
		}
	} else {
		for (let i = 0; i < window.localStorage.length; i++) {
			const rawKey = window.localStorage.key(i)
			if (!rawKey || !rawKey.startsWith(keyName)) continue
			list.push({
				name: rawKey,
				content: getStore({
					name: rawKey.replace(keyName, '')
				})
			})
		}
	}
	return list
}

export const clearStore = (params: any = {}) => {
	const { type } = params
	if (type) {
		window.sessionStorage.clear()
	} else {
		window.localStorage.clear()
	}
}
